<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'ContractBian'
    };
</script>

<style lang="less" scoped>
</style>
